import RpcService             from '@/core/services/Rpc/RpcService';
import RpcResponse            from '@/core/services/Rpc/RpcResponse';

import type DriverFeedback    from '@/domains/Drivers/DriverFeedback';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с оценками водителей
 */
class DriverFeedbacksDAO {

  /**
   * Загружает список оценок
   */
  static async getList(
    filters?: {
      id?: number;
      driverId?: number;
      ownerId?: number;
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort,
  ): Promise<RpcResponse> {
    return await RpcService.makeRequest(
      'driverFeedbacks.getList',
      filters,
      pagination,
      sort,
      true, null, null, false,
      { abortPrevious: true },
    );
  }

  /**
   * Ставит оценку от имени текущего пользователя либо изменяет ранее поставленную.
   * Существующую оценку бэк ищет по водителю и автору, id с фронта для этого не нужен
   */
  static async upsert(driverFeedback: DriverFeedback): Promise<RpcResponse> {
    return await RpcService.makeRequest('driverFeedbacks.upsert', { driverFeedback });
  }
}

export default DriverFeedbacksDAO;
